import { defineComponent, onMounted, computed, ref, inject, nextTick, watch, onBeforeUnmount, createBlock, createCommentVNode, unref, openBlock, resolveDynamicComponent } from "vue";
import { isFilled, asHTML } from "@prismicio/client";
import { DEV } from "esm-env";
import { routerKey } from "vue-router";
import { devMsg } from "../lib/devMsg.js";
import { isInternalURL } from "../lib/isInternalURL.js";
import { usePrismic } from "../usePrismic.js";
const defaultWrapper = "div";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "DeprecatedPrismicRichText" },
  __name: "DeprecatedPrismicRichText",
  props: {
    field: {
      type: Array
    },
    fallback: {
      type: String
    },
    linkResolver: {
      type: Function
    },
    serializer: {
      type: [Object, Function]
    },
    wrapper: {
      type: [String, Object, Function]
    }
  },
  setup(__props) {
    const props = __props;
    const { options } = usePrismic();
    if (DEV) {
      onMounted(() => {
        console.warn(
          `[PrismicRichText] You're using the deprecated version of \`<PrismicRichText>\` because either the \`serializer\` prop or the plugin \`richTextSerializer\` option were provided. This API will be removed in a future major. For more details, see ${devMsg(
            "html-serialization-is-deprecated-with-prismic-rich-text"
          )}`
        );
      });
    }
    const html = computed(() => {
      if (!isFilled.richText(props.field)) {
        return props.fallback ?? "";
      }
      const linkResolver = props.linkResolver ?? options.linkResolver;
      const serializer = props.serializer ?? options.richTextSerializer;
      return asHTML(props.field, { linkResolver, serializer });
    });
    const root = ref(null);
    const maybeRouter = inject(routerKey, null);
    let links = [];
    const navigate = function(event) {
      event.preventDefault();
      maybeRouter == null ? void 0 : maybeRouter.push(this.href);
    };
    const addListeners = () => {
      const node = root.value && "$el" in root.value ? root.value.$el : root.value;
      if (node && "querySelectorAll" in node) {
        links = Array.from(node.querySelectorAll("a")).map((element) => {
          const href = element.getAttribute("href");
          if (href && isInternalURL(href)) {
            const listener = navigate.bind({ href });
            element.addEventListener("click", listener);
            return { element, listener };
          } else {
            return false;
          }
        }).filter((link) => link);
      }
    };
    const removeListeners = () => {
      links.forEach(
        ({ element, listener }) => element.removeEventListener("click", listener)
      );
      links = [];
    };
    onMounted(() => {
      removeListeners();
      nextTick(addListeners);
    });
    watch(html, () => {
      removeListeners();
      nextTick(addListeners);
    });
    onBeforeUnmount(() => {
      removeListeners();
    });
    return (_ctx, _cache) => {
      return unref(isFilled).richText(__props.field) || __props.fallback ? (openBlock(), createBlock(resolveDynamicComponent(__props.wrapper || defaultWrapper), {
        key: 0,
        ref_key: "root",
        ref: root,
        innerHTML: html.value
      }, null, 8, ["innerHTML"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DeprecatedPrismicRichText.vue.js.map
